import React from 'react'
import {
    List,
    Datagrid,
    TextField as TextFieldRa,
    EditButton,
    TextInput,
    SimpleForm,
    Edit,
    DeleteButton,
    required,
    Create,
    BooleanInput,
    BooleanField,
    FunctionField,
    NumberInput,
    SelectInput,
} from 'react-admin'
import Icon from '@mui/icons-material/AddLocationAlt'
import { DESTINATION_CATEGORY_CODES } from '../../../consts'

const destinationCategoryChoices = Object.entries(DESTINATION_CATEGORY_CODES).map(
    ([id, name]) => ({ id: Number(id), name })
)

export const DestinationsIcon = Icon

export const DestinationsList = ({ permissions, ...props }) => {
    return (
        <List
            {...props}
            exporter={false}
            title="Seguradoras"
            bulkActionButtons={false}
            sort={{ field: 'name', order: 'ASC' }}
            perPage={25}
        >
            <Datagrid>
                <TextFieldRa source="name" label="Nome" />
                <BooleanField source="active" label="Ativo" />
                <FunctionField
                    source="category"
                    label="Categoria"
                    render={(record) =>
                        DESTINATION_CATEGORY_CODES[record.category] ||
                        record.category
                    }
                />
                <EditButton label="" />
                <DeleteButton label="" mutationMode={'pessimistic'} />
            </Datagrid>
        </List>
    )
}

export const DestinationsEdit = (props) => {
    return (
        <Edit {...props}>
            <SimpleForm redirect="list">
                <TextInput label="Nome" source="name" validate={[required()]} />
                <TextInput label="Código Universal" source="codeUniversal" />
                <TextInput label="Código AssistCard" source="codeAssistCard" />
                <TextInput label="Código Coris" source="codeCoris" />
                <TextInput label="Código Affinity" source="codeAffinity" />
                <TextInput label="Código GTA" source="codeGta" />
                <TextInput label="Código Omint" source="codeOmint" />
                <TextInput label="Código Hero" source="codeHero" />
                 <TextInput label="Código MTA" source="codeMta" />
                <TextInput label="Código Intermac" source="codeIntermac" />
                <TextInput label="Código Ita" source="codeIta" />
                <NumberInput label="Ordem" source="order" />
                <TextInput label="Label" source="label" />
                <SelectInput label="Categoria" source="category" choices={destinationCategoryChoices} />
                <BooleanInput label="Ativo" source="active" />
            </SimpleForm>
        </Edit>
    )
}

export const DestinationsCreate = (props) => {
    return (
        <Create {...props}>
            <SimpleForm redirect="list">
                <TextInput label="Nome" source="name" validate={[required()]} />
                <TextInput label="Código Universal" source="codeUniversal" />
                <TextInput label="Código AssistCard" source="codeAssistCard" />
                <TextInput label="Código Coris" source="codeCoris" />
                <TextInput label="Código Affinity" source="codeAffinity" />
                <TextInput label="Código GTA" source="codeGta" />
                <TextInput label="Código Omint" source="codeOmint" />
                <TextInput label="Código Hero" source="codeHero" />
                <TextInput label="Código MTA" source="codeMta" />
                <TextInput label="Código Intermac" source="codeIntermac" />
                <TextInput label="Código Ita" source="codeIta" />
                <NumberInput label="Ordem" source="order" />
                <TextInput label="Label" source="label" />
                <SelectInput label="Categoria" source="category" choices={destinationCategoryChoices} />
                <BooleanInput label="Ativo" source="active" />
            </SimpleForm>
        </Create>
    )
}
